import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { Table } from 'react-bootstrap';
const EmployeeDetailFiles = _ref => {
  let {
    employeeDetailFiles,
    deleteEmployeeFile
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Table, {
    responsive: "md"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('file')), /*#__PURE__*/React.createElement("th", null, t('uploaded_by')), /*#__PURE__*/React.createElement("th", null, t('date')), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, employeeDetailFiles.map(employeeDetailFile => {
    return /*#__PURE__*/React.createElement("tr", {
      key: employeeDetailFile.id
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
      href: employeeDetailFile.file.url,
      target: "_blank",
      rel: "noreferrer"
    }, employeeDetailFile.file.filename)), /*#__PURE__*/React.createElement("td", null, employeeDetailFile.uploaded_by), /*#__PURE__*/React.createElement("td", null, createTimezonedDate(new Date(employeeDetailFile.created_at), true).toCustomLocaleTimeString()), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(DeleteButton, {
      style: {
        marginRight: '8px'
      },
      onClick: () => deleteEmployeeFile(employeeDetailFile.id, employeeDetailFile.file.filename)
    })));
  })));
};
export default EmployeeDetailFiles;